(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var jsonEl = document.querySelector('[data-faq-json]');
  if (!jsonEl) return;
  var categories;
  try { categories = JSON.parse(jsonEl.textContent); } catch(e) { return; }

  var tabsWrap   = document.querySelector('[data-faq-tabs]');
  var accordion   = document.querySelector('[data-faq-accordion]');
  var schemaEl    = document.querySelector('[data-faq-schema]');

  // Build category tabs
  categories.forEach(function(cat, i) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tr-faq-tab';
    btn.setAttribute('data-faq-tab', i);
    btn.textContent = cat.title;
    tabsWrap.appendChild(btn);
  });

  // Build accordion HTML
  function renderAccordion(filter) {
    var html = '';
    categories.forEach(function(cat, ci) {
      if (filter !== 'all' && String(ci) !== String(filter)) return;
      html += '<div class="tr-faq-category" data-faq-cat="' + ci + '">';
      if (filter === 'all') {
        html += '<h2 class="tr-faq-category__title">' + cat.title + '</h2>';
      }
      cat.items.forEach(function(item, ii) {
        html += '<div class="tr-faq-item">';
        html += '<button type="button" class="tr-faq-question" aria-expanded="false">';
        html += '<span>' + item.q + '</span>';
        html += '<svg class="tr-faq-chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        html += '</button>';
        html += '<div class="tr-faq-answer"><p>' + item.a + '</p></div>';
        html += '</div>';
      });
      html += '</div>';
    });
    accordion.innerHTML = html;
    bindAccordion();
  }

  function bindAccordion() {
    accordion.querySelectorAll('.tr-faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.tr-faq-item');
        var isOpen = item.classList.contains('is-open');
        // Close all others
        accordion.querySelectorAll('.tr-faq-item.is-open').forEach(function(el) {
          el.classList.remove('is-open');
          el.querySelector('.tr-faq-question').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (typeof window.gtag === 'function') {
            var qText = btn.querySelector('span') ? btn.querySelector('span').textContent.substring(0, 100) : '';
            window.gtag('event', 'faq_question_clicked', { question: qText });
          }
        }
      });
    });
  }

  // Tab click handler
  tabsWrap.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-faq-tab]');
    if (!tab) return;
    tabsWrap.querySelectorAll('.tr-faq-tab').forEach(function(t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
    if (typeof window.gtag === 'function') window.gtag('event', 'faq_tab_clicked', { tab_name: tab.textContent.trim() });
    renderAccordion(tab.dataset.faqTab);
  });

  // Initial render
  renderAccordion('all');

  // Schema.org FAQPage JSON-LD
  if (schemaEl) {
    var entities = [];
    categories.forEach(function(cat) {
      cat.items.forEach(function(item) {
        entities.push({
          '@type': 'Question',
          'name': item.q,
          'acceptedAnswer': { '@type': 'Answer', 'text': item.a }
        });
      });
    });
    schemaEl.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': entities
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
